export const getAMNReferralSourceFromQueryParam = (): string => {
	return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
